export type Net4SecuritySocialKind = 'naf' | 'ccc';

export function securitySocialKind(type: string): Net4SecuritySocialKind | undefined {
  if (!/^\d{1,2}$/u.test(type)) return undefined;
  const code = Number(type);
  if ([1, 3, 4, 6].includes(code)) return 'naf';
  if ([2, 5, 9].includes(code)) return 'ccc';
  return undefined;
}

export function normalizeSecuritySocialNumber(value: string, kind?: Net4SecuritySocialKind): string {
  const number = value.replace(/[\s-]+/gu, '');
  return kind === 'ccc' && /^\d{11}$/u.test(number)
    ? `${number.slice(0, 2)}0${number.slice(2)}`
    : number;
}

export function securitySocialNumberError(value: string, kind?: Net4SecuritySocialKind): string | undefined {
  const number = normalizeSecuritySocialNumber(value, kind);
  if (!number) return undefined;
  if (!/^\d{12}$/u.test(number)) {
    return kind === 'ccc' ? 'El CCC debe tener 11 dígitos, o 12 con el cero de NET4.' : 'El número SS debe tener 12 dígitos.';
  }
  if (number === '000000000000' || number === '999999999999') return 'Introduce un número SS válido.';
  if (!kind) return 'Selecciona el tipo de identificación para validar el número SS.';
  if (kind === 'ccc' && number[2] !== '0') return 'El CCC de 12 dígitos debe llevar un cero después de la provincia.';
  const province = number.slice(0, 2);
  const body = number.slice(2, 10);
  const significantBody = kind === 'ccc' && body.startsWith('00') ? body.slice(2)
    : body.startsWith('0') ? body.slice(1) : body;
  const expectedControl = String(Number(`${province}${significantBody}`) % 97).padStart(2, '0');
  if (number.slice(10) !== expectedControl) {
    return `El ${kind === 'naf' ? 'NAF' : 'CCC'} no es válido: revisa el número y los dígitos de control.`;
  }
  return undefined;
}
